import React, { useState } from "react";
import "./CorporateBanner.css";
import Modal from "../../../Pages/ModalForm";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const CorporateBanner = ({ onLoad }) => {
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/BBT/New%20Banners%20all%20pages/SEO_MEDIA/Corporate_Travel_Management_Banner.webp"
            alt="Corporate Travel Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-2 mt-md-1">
              <p className="fs4 text-uppercase busy">SIMPLIFY YOUR</p>
              <HeadingH1 className="banner-headings w-75">
                Corporate Travel with Blueberry
              </HeadingH1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Corporate travel shouldn’t slow you down! From flight to hotel
                  bookings and beyond, we simplify the process with priority
                  support, real-time updates, and cost-saving solutions.
                </div>
              </div>
              <div className="bannercarousel mt-md-3 mt-xxl-5">
                <button
                  className="btn fs4 fw-bold bg-transparent text-white text-uppercase leeter"
                  type="submit"
                  onClick={handleShow}
                >
                  Find Out More
                </button>
              </div>
              <Modal show={showModal} handleClose={handleClose} />
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default CorporateBanner;
